export enum ReportsFieldType {
    Date = 'dateField',
    Number = 'numberField',
    String = 'stringField',
}